import { createSelector } from "reselect";
import get from "lodash.get";
import { createPolicyForInternalNameSelector } from "src/selectors/data_selectors";

//Constants
import { policyInternalNames } from "src/constants";

/**
 * Memoized selector to determine if patient app is enabled for dashboard
 */

export const patientAppDashboardEnabledSelector = createSelector(
  createPolicyForInternalNameSelector(
    policyInternalNames.patientAppDashboardEnabled
  ),
  policy => {
    return get(policy, "attributes.policyValue", false);
  }
);
